import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
import Lity from "lity";


// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function ($) {
    Components.init();
    Plugins.init();
});


// Dynamically set grid-template-columns for .show001 grids on desktop
document.addEventListener("DOMContentLoaded", function () {
    const rowElements = document.querySelectorAll('.show001_row');

    rowElements.forEach(function (ul) {
        let columnCount = ul.querySelectorAll('.show001_col').length;
        ul.style.setProperty('grid-template-columns', 'repeat(' + columnCount + ', 1fr)');
        const classToAdd = columnCount + '-col-row';
        ul.classList.add(classToAdd);

        // Apply class directly to ul based on column count
        if (classToAdd === '2-col-row') {
            ul.classList.add('half-img-large');
            ul.classList.remove('half-img-small'); // Ensure to remove the other class if it was previously added
        } else if (classToAdd === '3-col-row') {
            ul.classList.add('half-img-small');
            ul.classList.remove('half-img-large'); // Ensure to remove the other class if it was previously added
        }
    });
});

// Update colour of the paragraph inside a WYSIWYG with the class "description"
document.addEventListener('DOMContentLoaded', function () {
    var descriptionElements = document.querySelectorAll('.description');

    descriptionElements.forEach(function (descriptionElement) {
        // Split the className string into an array of individual classes
        var classesArray = descriptionElement.className.split(' ');
        // Filter to only include classes that start with 'text-'
        var textClasses = classesArray.filter(function (className) {
            return className.startsWith('text-');
        });
        // Find all <p>, <h1>, <h2>, <h3>, <h4>, <h5>, <h6>, and <li> elements within the current descriptionElement
        var targetElements = descriptionElement.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li');
        targetElements.forEach(function (element) {
            // Apply each of the textClasses to the element
            textClasses.forEach(function (className) {
                element.classList.add(className);
            });
        });
    });
});

// Update tab colour for gchoice_conditional - custom gravity forms radio buttons class
// Update tab colour for purchase form
document.addEventListener('DOMContentLoaded', function () {
    // Target the .gform_fields within .contains_conditional that has .gchoice_conditional
    var containers = document.querySelectorAll('.contains_conditional .gform_fields .gchoice_conditional');

    containers.forEach(function (container) {
        // Listen for changes within each container
        container.addEventListener('change', function (e) {
            // Ensure the change event is coming from a radio input
            if (e.target && e.target.classList.contains('gfield-choice-input')) {
                console.log('Radio button clicked:', e.target.id); // Debugging

                // Targeting the parent .gchoice of the clicked input to reset styles broadly
                var choices = container.querySelectorAll('.gchoice');
                choices.forEach(function (choice) {
                    // Reset styling for all labels
                    var label = choice.querySelector('label'); // Ensure correct selector for label
                    if (label) {
                        label.style.backgroundColor = ''; // Reset to default
                        label.style.color = ''; // Reset to default
                        label.style.fontWeight = ''; // Reset font-weight to default or 'normal'
                    }
                });

                // Apply 'selected' styling to the clicked radio's corresponding label
                var clickedLabel = document.querySelector('label[for="' + e.target.id + '"]');
                if (clickedLabel) {
                    clickedLabel.style.backgroundColor = '#e2e4e6'; // Change background color
                    clickedLabel.style.color = '#8F1860'; // Change text color
                    clickedLabel.style.fontWeight = '600'; // Set font-weight to bold
                }
            }
        });
    });
});


// Read More button for revealing text on single-person page 
document.addEventListener('DOMContentLoaded', function () {
    const readMoreBtn = document.querySelector('.read-more-btn');
    const shortDescription = document.querySelector('.short-description');
    const fullDescription = document.querySelector('.full-description');
    if (readMoreBtn !== null) {
        readMoreBtn.addEventListener('click', function () {
            // Toggle visibility
            shortDescription.classList.toggle('hidden');
            fullDescription.classList.toggle('hidden');

            // Update button text accordingly
            if (fullDescription.classList.contains('hidden')) {
                readMoreBtn.textContent = 'Read more';
            } else {
                readMoreBtn.textContent = 'Read less';
            }
        });
    }
});
